import { render, staticRenderFns } from "./video-id-presenter.vue?vue&type=template&id=84095f6e&scoped=true&"
import script from "./video-id-presenter.vue?vue&type=script&lang=js&"
export * from "./video-id-presenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84095f6e",
  null
  
)

export default component.exports